var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_288",
    "data-name": "Group 288",
    transform: "translate(-987 -154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_285",
    "data-name": "Group 285",
    transform: "translate(-108 -814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_70",
    d: "M0 0H56V56H0z",
    "data-name": "Rectangle 70",
    transform: "translate(1095 968)",
    style: {
      fill: "#00ff6f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_636",
    "data-name": "Group 636",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_73",
    "data-name": "Ellipse 73",
    transform: "translate(1004 168)",
    style: {
      stroke: "#fff",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_244",
    d: "M6.509-6L4.264-2.468v4.409H1.9v-4.409L-.36-6h2.4l1.02 1.636L4.159-6z",
    "data-name": "Path 244",
    transform: "translate(1011.691 181.224)",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyCoin);
export default __webpack_public_path__ + "static/media/buy-coin.612168c3a36bca81ecb697776a53b619.svg";
export { ForwardRef as ReactComponent };